import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";

export default function UploadModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
  };

  const handleSave = () => {
    // Handle save logic here
  };

  return modal.is_active && modal.type === 'upload' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card column is-3">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            Bankruptcy
          </p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ height: "110px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column">
              <h3> Upload the necessary documents related to the customers bankruptcy.</h3>
            </div>
            <div className="column">
              <button type="button" className="button is-link is-small">
                <span className="mx-5">Upload</span>
              </button>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
            <button type="submit" className="button is-link is-small" onClick={handleSave}>Save</button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
